import { clientBase } from "../common";

export const get_questions_mounted_course = (_body) => {
  return clientBase(`v1/students/questions/getQuestions`, "POST", {
    body: _body,
  });
};

export const post_questions_course = (_body) => {
  return clientBase(`v1/students/questions/newQuestion`, "POST", {
    body: _body,
  });
};

export const put_questions_course = (_body) => {
  return clientBase(`v1/students/questions/updateQuestion`, "PUT", {
    body: _body,
  });
};

export const post_answer_course = (_body) => {
  return clientBase(`v1/students/answers/newAnswers`, "POST", {
    body: _body,
  });
};

export const delete_questions_course = (_question_id) => {
  return clientBase(
    `v1/students/questions/deleteQuestion/${_question_id}`,
    "DELETE"
  );
};

export const delete_answer_course = (_answer_id) => {
  return clientBase(
    `v1/students/answers/deleteAnswers/${_answer_id}`,
    "DELETE"
  );
};
